import React from 'react';
import type ProjectSettingsServiceDeskAutomationCreateRuleType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-create-rule/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationCreateRule = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationCreateRuleType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-create-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-create-rule" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-create-rule'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationCreateRule}
		pageId="project-settings-automation-create-rule"
		shouldShowSpinner
	/>
);
